import { NotifyHelper } from '../../../helpers/toast';
import { eThangDiemActionTypeDefine } from '../../action-types/IThangDiemActionType';
import { generateActionForKey, generateActions } from '../generateActions';

export const thangDiemActions = {
    ...generateActions(eThangDiemActionTypeDefine, "THANG_DIEM"),
    ...generateActionForKey(eThangDiemActionTypeDefine, "THANG_DIEM",
        "SAVE_SUCCESS", () => { NotifyHelper.Success("Lưu thành công") }
    ),
    ...generateActionForKey(eThangDiemActionTypeDefine, "THANG_DIEM",
        "DELETE_SUCCESS", () => { NotifyHelper.Success("Xóa thành công") }
    ),
    ...generateActionForKey(eThangDiemActionTypeDefine, "THANG_DIEM",
        "SAVE_ERROR", (m) => { NotifyHelper.Error(m || "Có lỗi xảy ra") }
    ),
    ...generateActionForKey(eThangDiemActionTypeDefine, "THANG_DIEM",
        "DELETE_ERROR", (m) => { NotifyHelper.Error(m || "Có lỗi xảy ra") }
    ),
}
